import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useRef, useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  GetAllCitiesByProvinceId,
  GetAllProvinces,
} from "../../services/ProvinceService";
import {
  CreateCategories,
  GetAllCategories,
  GetCategoryById,
} from "../../services/CategoryService";
import {
  CreateNotice,
  GetPreDraft,
  SetUpDraft,
} from "../../services/NoticeService";
import imageCompression from "browser-image-compression";
import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DropzoneArea } from "material-ui-dropzone";
import { useDropzone } from "react-dropzone";
import { toast } from "react-hot-toast";
import { log } from "@grpc/grpc-js/build/src/logging";
import {
  Button as MButton,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
//import { DropzoneArea } from "material-ui-dropzone";
import * as signalR from "@microsoft/signalr";
import { UploadImage } from "../../services/MediumService";
import { BaseGUrl } from "../../services/global";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import { useDispatch, useSelector } from "react-redux";
import { GetPositionRoleByPositionIdAndRole } from "../../services/PositionService";

export interface FileDto {
  data: string | null | undefined;
  name: string;
  type: string;
}
export interface NoticeDto {
  id: any;
  files: FileDto[];
  title: string;
  description: string;
  categoryId: string;
  noticeType: number;
  image: string;
}
const NewNotice2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const myPositions = useSelector(getMyPosition);
  useEffect(() => {
    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync();
      }
    }
  }, [myPositions]);

  const [CreateAdv, setCreateAdv] = useState(false);
  async function GetPositionRoleByPositionIdAndRoleAsync() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "CreateAdv"
    ).then((p) => {
      if (p.data.data === false) {
        navigate("/");
      } else {
        setCreateAdv(true);
      }
    });
  }

  const formik = useFormik<NoticeDto>({
    initialValues: {
      id: null,
      files: [],
      categoryId: "",
      description: "",
      image: "",
      noticeType: 0,
      title: "",
    },
    validationSchema: Yup.object().shape({
      files: Yup.array().required("لطفا فایل را وارد کنید"),
      description: Yup.string().required("لطفا توضیحات را وارد نمایید"),
      title: Yup.string().required("لطفا عنوان آگهی را وارد نمایید"),
    }),
    onSubmit: async (values) => {
      //console.log(getNoticeData);

      console.log(values);
      await CreateNotice(values).then((p) => navigate("/"));

      //submitChangePassword(values);
    },
  });

  const handleFileChange = (event: any) => {
    console.log(event.target.files);

    //setFiles([...event.target.files]);
  };

  const params = useParams();
  useEffect(() => {
    // console.log(params.type?.toLowerCase() === "sell" ? 0 : 1);
    GetProvinces();
    GetCategories();
    dispatch(fetchUserPosition());
  }, []);

  const [getVisibleNew, setVisibleNew] = useState(false);
  const [getVisible, setVisible] = useState(false);
  const [getCityAndCount, SetCityAndCount] = useState([]);
  const [getCategories, SetCategories] = useState([]);
  const [getProvinces, SetProvinces] = useState([]);
  const [getCities, SetCities] = useState([]);
  const [getFetchNextCategory, SetFetchNextCategory] = useState({
    lastSelectedDropDownId: "",
    lastSelectedDropDownIndex: 0,
  });
  const [getSelectedCityAndProvince, SetSelectedCityAndProvince] = useState({
    provinceId: "",
    cityId: "",
    count: 0,
    cityCaption: "",
  });
  const [getNewCategory, setNewCategory] = useState({
    localizedName: "",
    parentId: "",
    input: 0,
  });

  const [getNoticeData, SetNoticeData] = useState({
    title: "",
    description: "",
    noticeType: params.type?.toLowerCase() === "sell" ? 0 : 1,
    categoryId: "",
    image: null,
    locationVolumes: [],
  });

  const [files, setFiles] = useState<File[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [cnnId, setCnnId] = useState<string | null>(null);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [draft, SetDraft] = useState();
  const abortControllerRef = useRef<AbortController | null>(null);

  const onDrop = (acceptedFiles: File[]) => {
    setFiles(acceptedFiles);
  };

  useEffect(() => {
    async function SetUpNewDraft() {
      await SetUpDraft({ key: "noticetype", value: "0" }).then((p) => {
        // console.log(p.data);
      });
    }
    async function GetNewDraftAsync() {
      await GetPreDraft().then((p) => {
        console.log(p.data);

        //SetDraft(p.data);
        formik.setFieldValue("title", p.data.title);
        formik.setFieldValue("id", p.data.id);
      });
    }

    SetUpNewDraft();
    GetNewDraftAsync();
  }, []);

  useEffect(() => {
    console.log("Hey", files);

    if (files.length <= 0) {
      return;
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setUploadInProgress(true);

    const formData = new FormData();
    const chunkSize = 10 * 10; // 1 MB
    const fileReader = new FileReader();
    let offset = 0;

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
    }

    async function fetchData() {
      try {
        // const response = await fetch(
        // 	`http://localhost:5029/api/v1/MediumFile/Upload?connectionId=${cnnId}&noticeId=${formik.values.id}`,
        // 	{
        // 		method: "POST",
        // 		body: formData,
        // 		signal: controller.signal,
        // 	}
        // );

        if (false) {
          // Upload successful
          toast.success("با موفقیت آپلود شد");
        } else {
          // Upload failed
        }
      } catch (err) {
        // Error occurred during upload
      } finally {
        setUploadInProgress(false);
        abortControllerRef.current = null;
      }
    }
    fetchData();
    //   newFetch();
  }, [files]);

  const cancelUpload = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };
  const saveCategory = async () => {
    console.log(getNewCategory);

    await CreateCategories(getNewCategory)
      .then((p) => LoadMe(getNewCategory.parentId, getNewCategory.input))
      .then((p) => setVisible(false));
  };

  const GetCategories = async () => {
    const rawData = await GetAllCategories();
    addDropDown({ selectedItem: "", cat: rawData.data.data });
  };

  const GetProvinces = async () => {
    const rawData = await GetAllProvinces();
    SetProvinces(rawData.data.data);
  };

  const updateDropDown = (index: any, value: any) => {
    //use to change state of selected item in dropdown

    let newCategories: any = [...getCategories];
    newCategories[index - 1]["selectedItem"] = value;
    SetCategories(newCategories);
  };

  const LoadMe = async (Parent: any, input: any) => {
    SetNoticeData({
      ...getNoticeData,
      ["categoryId"]: Parent,
    });
    updateDropDown(input, Parent);
    // console.log(e.target.id);
    let rawData = await GetCategoryById(Parent);
    addDropDown({ id: input, selectedItem: "", cat: rawData.data.data });
  };

  const FetchNextCategory = async (e: any) => {
    if (e.target.value === "00000000-0000-0000-0000-000000000000") {
      setNewCategory({
        ...getNewCategory,
        parentId: (getCategories[e.target.id - 2] as any).selectedItem,
        input: e.target.id - 1,
      });

      setVisible(true);
    } else {
      SetFetchNextCategory({
        lastSelectedDropDownId: e.target.value,
        lastSelectedDropDownIndex: e.target.id,
      });
      console.log(`Parent ${e.target.value}`);
      formik.setFieldValue("categoryId", e.target.value);
      await SetUpDraft({ key: "categoryid", value: e.target.value });
      console.log(e);
      console.log(getNewCategory);

      SetNoticeData({
        ...getNoticeData,
        ["categoryId"]: e.target.value,
      });
      updateDropDown(e.target.id, e.target.value);

      let rawData = await GetCategoryById(e.target.value);

      if (
        rawData.data.data.length === 0 ||
        rawData.data.data.length === undefined
      ) {
        setVisibleNew(true);
      } else {
        setVisibleNew(false);
      }
      addDropDown({
        id: e.target.id,
        selectedItem: "",
        cat: rawData.data.data,
      });
    }
  };

  const addDropDown = (input: any) => {
    if (input.id) {
      //console.log("RM" + input.id);
      SetCategories((current) =>
        current.filter((o) => (o as any).id < input.id + 1)
      );
    }

    console.log(input);
    SetCategories((current) => [
      ...current,
      {
        id: current.length + 1,
        catdata: input.cat,
        selectedItem: input.selectedItem,
      } as never,
    ]);
    //console.log(categories);
  };

  const addCityAndCount = (id: any) => {
    id.persist();
    id.preventDefault();
    //console.log(getCityAndCount);

    SetCityAndCount((current) => [
      ...current,
      {
        id: current.length + 1,
        cityId: getSelectedCityAndProvince.cityId,
        cityCaption: getSelectedCityAndProvince.cityCaption,
        provinceId: getSelectedCityAndProvince.provinceId,
        count: getSelectedCityAndProvince.count,
      } as never,
    ]);
  };
  const removeCityAndCount = (id: any) => {
    SetCityAndCount((current) => current.filter((o) => (o as any).id !== id));
  };

  const [totalSize, setTotalSize] = useState(0);

  const fileUploadRef = useRef(null);

  const SetSelectedProvinceDataInfo = (e: any) => {
    if (e.target.name === "provinceId") {
      LoadCities(e.target.value.id);
    }

    SetSelectedCityAndProvince({
      ...getSelectedCityAndProvince,
      [e.target.name]: e.target.value,
    });
    console.log(getSelectedCityAndProvince);
  };

  const LoadCities = async (provinceId: any) => {
    let data = await GetAllCitiesByProvinceId(provinceId);
    SetCities(data.data.data);
  };

  const SetDataInfo = (event: any) => {
    SetNoticeData({
      ...getNoticeData,
      [event.target.name]: event.target.value,
    });
  };

  const LimitChars = (event: any) => {
    console.log(event.target.value);
  };
  const footerContent = (
    <div>
      <Button
        label="انصراف"
        //icon="pi pi-times"
        onClick={() => setVisible(false)}
        className="p-button-text"
      />
      <Button
        label="ذخیره"
        //icon="pi pi-check"
        onClick={
          () => saveCategory()
          //console.log(newCategory)
        }
      />
    </div>
  );

  const headerTemplate = (options: any) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? (fileUploadRef.current as any).formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {/* {uploadButton} */}
        {cancelButton}
        {/* <ProgressBar
					value={value}
					displayValueTemplate={() => `${formatedValue} / 1 MB`}
					style={{
						width: "300px",
						height: "20px",
						marginLeft: "auto",
					}}></ProgressBar> */}
      </div>
    );
  };

  const itemTemplate = (file: any, props: any) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };
  const onTemplateSelect = (e: any) => {
    let _totalSize = totalSize;
    e.files.forEach((file: any) => {
      _totalSize += file.size;
    });
    setTotalSize(_totalSize);
  };
  const onTemplateUpload = (e: any) => {
    console.log(e);
  };

  const onTemplateRemove = (file: any, callback: any) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0);
  };

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        {/* <i
					className="pi pi-image mt-3 p-5"
					style={{
						fontSize: "5em",
						borderRadius: "50%",
						backgroundColor: "var(--surface-b)",
						color: "var(--surface-d)",
					}}></i> */}
        <span
          style={{
            display: "absolute",
            fontSize: "1.2em",
            color: "var(--text-color-secondary)",
          }}
          className="my-5"
        >
          لطفا بنر مربوط به آگهی را انتخاب کنید
        </span>
      </div>
    );
  };
  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  {
    /*DropDown Start */
  }

  const selectedCountryTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div>{option.localizedName}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option: any) => {
    return (
      <>
        <div className="country-item">
          {option.id === "00000000-0000-0000-0000-000000000000" ? (
            <>
              <div
                style={{ color: "green" }}
                // onClick={() => {
                //   setNewCategory({
                //     ...newCategory,
                //     parentId: option.parentCategoryId,
                //   });
                //   console.log(newCategory);
                // }}
              >
                {option.localizedName}
              </div>
            </>
          ) : (
            <>
              <div
                onClick={() => {
                  console.log(option);
                }}
              >
                {option.localizedName}
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  const UpdateDraft = async (key: string, value: string) => {
    if (key && value) await SetUpDraft({ key, value });
  };

  const countryOptionTemplate2 = (option: any) => {
    return (
      <div className="country-item">
        <div>ppp</div>
      </div>
    );
  };
  {
    /* Drop Down End */
  }

  const SetCategory = async () => {
    console.log(getCategories[getCategories.length - 2]["selectedItem"]);
    SetNoticeData((getData) => {
      return {
        ...getData,
        ["categoryId"]: getCategories[getCategories.length - 2]["selectedItem"],
      };
    });
  };
  const submit = async (e: any) => {
    e.preventDefault();

    SetNoticeData((getData) => {
      return {
        ...getData,
        ["locationVolumes"]: getCityAndCount,
      };
    });
    await CreateNotice(getNoticeData).then((p) => navigate("/"));
    console.log(getNoticeData);
    // (p) => navigate("/");
  };

  function dynamicSort(property: any) {
    return function (a: any, b: any) {
      return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    };
  }
  const customBase64Uploader = async (event: any) => {
    // convert file to base64 encoded
    const file = event.files[0];
    console.log("originalFile instanceof Blob", file instanceof Blob); // true
    console.log(`originalFile size ${file.size / 1024 / 1024} MB`);

    const options = {
      maxSizeMB: Number.POSITIVE_INFINITY,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      fileType: "image/jpeg",
      initialQuality: 1.0,
    };
    const compressedFile = await imageCompression(file, options);
    console.log(
      "compressedFile instanceof Blob",
      compressedFile instanceof Blob
    ); // true
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    const reader = new FileReader();
    //let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

    reader.readAsDataURL(compressedFile);
    reader.onloadend = async function () {
      const base64data = reader.result;

      // SetNoticeData({
      //   ...getNoticeData,
      //   ["image"]: base64data,
      // } as never);

      await UploadImage({ entityId: formik.values.id, medium: base64data });
      //formik.setFieldValue("image", base64data);

      //       console.log(getNoticeData);
      //
      //console.log(base64data);
    };
  };
  function handleFindIndex(data: FileDto[], value: string) {
    const index = data.findIndex((innerArray) => innerArray.name === value);
    return index;
  }
  function handleDelete(files: any) {
    let base64Strings = formik.values.files;
    let index = handleFindIndex(formik.values.files, files.name);
    let next = base64Strings.filter((base64, i) => i !== index);
    formik.setFieldValue("files", next);
  }
  function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const handleDrop = async (files: any) => {
    for (let i = 0; i < files.length; i++) {
      console.log(files[i]);
      await sleep(10000); // Sleep for 10 seconds
      console.log("Done");

      return;

      //console.log(1);

      const reader = new FileReader();
      let base64Strings = formik.values.files;
      reader.onloadend = () => {
        // console.log(2);
        const base64String = reader.result;
        // console.log(base64String);

        base64Strings.push({
          data: base64String?.toString(),
          name: files[i].name,
          type: files[i].type,
        });

        // if (base64Strings.length === files.length) {
        //   console.log(3);
        //   console.log(base64Strings);
        // }
      };
      reader.readAsDataURL(files[i]);
      // console.log(base64Strings);
    }

    //let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url
    /*
    

    (test as any).push([files[0].name, "1"]);
    handleFindIndex(test, files[0].name);

    formik.setFieldValue("files", test).then((p) => console.log(p));
    */
    //let test2 = formik.values.files;
    // console.log(test2);
    // console.log("handle drop . . .");
    // console.log(files);
  };

  function handleUploadProgress(progressEvent: any) {
    // handle the upload progress here
  }
  return (
    <>
      {CreateAdv === true ? (
        <>
          <div className="mt-5 mb-5 container">
            <hr />
            <div className="card p-2">
              <b className="py-2">
                <> آگهی جدید</>
              </b>

              <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
                <RadioGroup
                  row
                  defaultValue="1"
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  onChange={async (e) =>
                    await SetUpDraft({
                      key: "noticetype",
                      value: (e.target as any).value,
                    })
                  }
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="اعلان نیاز"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="اعلان فروش"
                  />
                </RadioGroup>
              </div>
              <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
                <Dialog
                  header="افزودن دسته بندی جدید"
                  visible={getVisible}
                  onHide={() => setVisible(false)}
                  footer={footerContent}
                  className="col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block"
                >
                  <InputText
                    name="title"
                    type="text"
                    onKeyUp={(e) =>
                      e.code === "Enter" || e.code === "NumpadEnter"
                        ? saveCategory()
                        : e.defaultPrevented
                    }
                    style={{ width: "100%" }}
                    className="block mb-2"
                    placeholder="عنوان"
                    autoFocus
                    onChange={(e) => {
                      setNewCategory({
                        ...getNewCategory,
                        localizedName: e.target.value,
                      });
                    }}
                  />
                </Dialog>

                <div className="col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
                  <InputText
                    id="title"
                    {...formik.getFieldProps("title")}
                    type="text"
                    style={{ width: "100%", marginLeft: "5px" }}
                    className="block mb-2"
                    placeholder="عنوان"
                    onBlur={async (e) =>
                      await SetUpDraft({
                        key: "title",
                        value: e.target.value,
                      })
                    }
                    //onChange={SetDataInfo}
                  />
                </div>

                <div className="p-2 col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
                  عنوان آگهی به دیده شدن آن کمک بسیاری میکند ، در انتخاب عنوان
                  آگهی دقت فرمایید
                </div>
              </div>
              {getCategories.map((p) =>
                ((p as any).catdata as any).length > 0 ? (
                  <div key={(p as any).id} id={(p as any).id}>
                    <div className="col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
                      <Dropdown
                        id={(p as any).id}
                        name="categoryId"
                        style={{ width: "100%", marginLeft: "0.3rem" }}
                        value={(p as any).selectedItem}
                        options={(p as any).catdata}
                        optionGroupChildren={(p as any).catdata}
                        onChange={FetchNextCategory}
                        optionLabel="name"
                        optionValue="id"
                        showClear={false}
                        filterBy="name"
                        // filter
                        placeholder="دسته بندی"
                        valueTemplate={selectedCountryTemplate}
                        itemTemplate={countryOptionTemplate}
                        optionGroupTemplate={countryOptionTemplate2}
                        //onSelect={(p) => console.log(p.currentTarget)}
                        //footer={countryOptionTemplate}
                      />
                    </div>
                    <div className="p-2 col-lg-6  col-xs-12 d-md-inline-flex d-sm-block d-xs-inline-block">
                      دسته بندی مناسب برای آگهی به جستجوی بهتر توسط سایر همکاران
                      کمک میکند
                    </div>
                  </div>
                ) : (
                  <p key={(p as any).id}>{(p as any).selectedItem}</p>
                )
              )}
              <div
                className="py-2"
                style={{
                  cursor: "pointer",
                  display: getVisibleNew ? "block" : "none",
                }}
                onClick={() => {
                  setVisible(true);
                  setNewCategory({
                    ...getNewCategory,
                    parentId: getFetchNextCategory.lastSelectedDropDownId,
                    input: getFetchNextCategory.lastSelectedDropDownIndex,
                  });
                }}
              >
                نیاز به دسته بندی جدید دارید ؟
              </div>
              <div>
                <InputTextarea
                  id="description"
                  {...formik.getFieldProps("description")}
                  style={{ width: "100%" }}
                  placeholder={"توضیحات"}
                  rows={7}
                  maxLength={7}
                  onBlur={async (e) =>
                    await SetUpDraft({
                      key: "description",
                      value: e.target.value,
                    })
                  }
                  //onChange={LimitChars}
                />
              </div>
              <div className="mb-2">
                <div className="parent-container my-2" dir="ltr">
                  <div
                    style={
                      uploadProgress > 0 && uploadProgress < 100
                        ? { display: "block" }
                        : { display: "none" }
                    }
                    className="overlay-panels "
                  >
                    <MButton
                      className="mt-5 pt-1"
                      style={{ fontSize: "1rem" }}
                      type="button"
                    >
                      منصرف شدم
                    </MButton>
                  </div>
                  <DropzoneArea
                    showAlerts={[]}
                    alertSnackbarProps={{}}
                    onDrop={onDrop}
                    onDelete={handleDelete}
                    previewText="فایل های انتخاب شده"
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    //previewChipProps={{ classes: { root: "mx-5" } }}
                    filesLimit={10}
                    //dropzoneText="فایل ها را برای آپلود در اینجا رها کنید یا  کلیک کنید"
                    dropzoneText={
                      uploadProgress > 0 && uploadProgress < 100
                        ? `%در حال آپلود فایل های شما هستیم ، لطفا منتظر بمانید ${uploadProgress}`
                        : "فایل ها را برای آپلود در اینجا رها کنید یا  کلیک کنید"
                    }
                    onChange={(files) => console.log("Files:", files)}
                    maxFileSize={5000000000}
                    dropzoneProps={
                      {
                        //disabled: true,
                      }
                    }
                  />
                </div>
                {/* <DropzoneArea
              showPreviews={true}
              showPreviewsInDropzone={false}
              useChipsForPreview
              previewGridProps={{ container: { spacing: 1, direction: "row" } }}
              previewText="Selected files"
            /> */}

                <FileUpload
                  ref={fileUploadRef}
                  name="img"
                  // url="https://primefaces.org/primereact/showcase/upload.php"
                  multiple={false}
                  //accept="image/*"
                  maxFileSize={20000000}
                  invalidFileSizeMessageSummary=" "
                  invalidFileSizeMessageDetail="حداکثر حجم آپلود عکس 1 مگابایت می باشد"
                  onUpload={onTemplateUpload}
                  onSelect={customBase64Uploader}
                  onError={onTemplateClear}
                  onClear={onTemplateClear}
                  headerTemplate={headerTemplate}
                  itemTemplate={itemTemplate}
                  emptyTemplate={emptyTemplate}
                  chooseOptions={chooseOptions}
                  uploadOptions={uploadOptions}
                  cancelOptions={cancelOptions}
                />
              </div>
            </div>
            {/*  
        <hr />
        <div className="card p-2">
          <b className="py-2">محله</b>
          <div className="col-12">
            <div className="col-lg-4 mb-2 col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
              <Dropdown
                name="provinceId"
                style={{ width: "100%", marginLeft: "0.3rem" }}
                value={getSelectedCityAndProvince.provinceId}
                options={getProvinces}
                onChange={SetSelectedProvinceDataInfo}
                optionLabel="name"
                // filter
                showClear={false}
                filterBy="name"
                placeholder="استان"
                valueTemplate={selectedCountryTemplate}
                itemTemplate={countryOptionTemplate}
              />
            </div>
            <div className="col-lg-4 mb-2 col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
              <Dropdown
                name="cityId"
                style={{ width: "100%", marginLeft: "0.3rem" }}
                value={getSelectedCityAndProvince.cityId}
                options={getCities}
                onChange={SetSelectedProvinceDataInfo}
                optionLabel="localizedName"
                // filter
                showClear={false}
                filterBy="localizedName"
                placeholder="شهر"
                valueTemplate={selectedCountryTemplate}
                itemTemplate={countryOptionTemplate}
                emptyMessage="لطفا ابتدا استان مورد نظر را انتخاب کنید"
              />
            </div>
            <div className="col-lg-4  col-xs-12 d-md-inline-flex d-sm-block d-xs-inline-block">
              <div>
                <InputText
                  name="count"
                  type="text"
                  style={{ width: "100%", marginLeft: "5px" }}
                  className="block mb-2"
                  placeholder="تعداد"
                  onChange={SetSelectedProvinceDataInfo}
                />
              </div>
              <div>
                <Button
                  icon="pi pi-plus"
                  onClick={addCityAndCount}
                  className="mx-2 p-button-info"
                />
              </div>
            </div>
          </div>
          {getCityAndCount
            .sort(dynamicSort("id"))
            .reverse()
            .map((p) => (
              <div className="col-12" key={(p as any).id}>
                <div className="col-lg-4 mb-2 col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
                  <Dropdown
                    disabled
                    style={{ width: "100%", marginLeft: "0.3rem" }}
                    value={(p as any).provinceId}
                    options={getProvinces}
                    optionLabel="localizedName"
                    // filter
                    showClear={false}
                    filterBy="localizedName"
                    placeholder="استان"
                    valueTemplate={selectedCountryTemplate}
                    itemTemplate={countryOptionTemplate}
                  />
                </div>
                <div className="col-lg-4 mb-2 col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
                  <Dropdown
                    disabled
                    style={{ width: "100%", marginLeft: "0.3rem" }}
                    value={(p as any).cityId.id}
                    placeholder={(p as any).cityId.localizedName}
                    valueTemplate={selectedCountryTemplate}
                    itemTemplate={countryOptionTemplate}
                  />
                </div>
                <div className="col-lg-4  col-xs-12 d-md-inline-flex d-sm-block d-xs-inline-block">
                  <div>
                    <InputText
                      disabled
                      value={(p as any).count}
                      name="title"
                      type="text"
                      style={{ width: "100%", marginLeft: "5px" }}
                      className="block mb-2"
                      placeholder="تعداد"
                    />
                  </div>
                  <div>
                    <Button
                      key={(p as any).id}
                      onClick={() => removeCityAndCount((p as any).id)}
                      id={(p as any).id.toString()}
                      icon="pi pi-minus"
                      className="mx-2 p-button-danger"
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      */}

            <div className="col-12 mt-2 px-2" style={{ width: "100%" }}>
              <Button
                label="ثبت"
                style={{ width: "45%", float: "right" }}
                onClick={async (e) =>
                  await SetUpDraft({
                    key: "noticestate",
                    value: "2",
                  }).then(() => navigate("/"))
                }
                //onClick={formik.submitForm}
                className="mt-3 mx-2 p-button-success"
              />
              <Button
                label="ذخیره در پیش نویس ها"
                style={{ width: "45%", float: "left" }}
                //onClick={cancelUpload}
                onClick={async (e) =>
                  await SetUpDraft({
                    key: "noticestate",
                    value: "1",
                  }).then(() => navigate("/"))
                }
                className="mt-3 mx-2 mb-3 p-button-success"
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default NewNotice2;
function getId(p: any) {
  console.log("enter");
  return (Math.random() * 10).toString();
}
